<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
    x="0px"
    y="0px"
    width="52px"
    height="52px"
    viewBox="0 0 50.8 50.8"
    style="enable-background:new 0 0 50.8 50.8;"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M25.4,0C11.4,0,0,11.4,0,25.4s11.4,25.4,25.4,25.4s25.4-11.4,25.4-25.4S39.4,0,25.4,0z M25.4,49.1
                        c-13,0-23.7-10.6-23.7-23.7S12.4,1.8,25.4,1.8s23.7,10.6,23.7,23.7S38.5,49.1,25.4,49.1z"
    />
    <path
      class="st0"
      d="M12.9,11.4l-1.2-1.3C7.4,14,4.9,19.6,4.9,25.4s2.5,11.4,6.8,15.3l1.2-1.3c-4-3.6-6.3-8.7-6.3-14
                        S8.9,15,12.9,11.4z"
    />
    <path
      class="st0"
      d="M39.1,10.1l-1.2,1.3c4,3.6,6.3,8.7,6.3,14s-2.3,10.4-6.3,14l1.2,1.3c4.3-3.9,6.8-9.5,6.8-15.3
                        S43.4,14,39.1,10.1z"
    />
    <rect x="19.7" y="4.3" class="st0" width="11.5" height="1.8" />
    <rect x="14.6" y="7.6" class="st0" width="21.7" height="1.8" />
    <rect x="19.7" y="44.6" class="st0" width="11.5" height="1.8" />
    <rect x="14.6" y="41.2" class="st0" width="21.7" height="1.8" />
    <path
      class="st0"
      d="M25.4,15.8c-6.2,0-11.3,5.1-11.3,11.3c0,1.7,0.4,3.3,1.1,4.8c0.2,0.5,0.7,0.8,1.3,0.8h17.8
                        c0.5,0,1-0.3,1.3-0.8c0.7-1.5,1.1-3.1,1.1-4.8C36.7,20.8,31.6,15.8,25.4,15.8z M28.5,26.6c0,1.7-1.4,3.1-3.1,3.1
                        c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c0.6,0,1.1,0.2,1.6,0.5l3.5-3.5l1.1,1.1L28.1,25C28.3,25.5,28.5,26,28.5,26.6z"
    />
  </svg>
</template>

<script>
export default {};
</script>
